<template>
  <v-container fluid>
    <v-col>
      <div class="gift-card-page">
        <v-btn-toggle
          v-if="routeName === 'GiftCardConfigListRoute' || routeName === 'GiftCardUniversalConfigListRoute'"
          tile
          color="primary"
          group
        >
          <v-btn :to="{ name: 'GiftCardConfigListRoute' }">
            Standard
          </v-btn>

          <v-btn :to="{ name: 'GiftCardUniversalConfigListRoute' }">
            Universal
          </v-btn>
        </v-btn-toggle>

        <v-row v-else>
          <v-col class="mb-3">
            <v-btn @click="prev" depressed>
              <v-icon
                left
                dark
              >
                mdi-arrow-left
              </v-icon>
              Back
            </v-btn>
          </v-col>
        </v-row>

        <router-view />
      </div>
    </v-col>
  </v-container>
</template>

<script>
export default {
  name: 'GiftCardPage',

  computed: {
    routeName() {
      return this.$route.name
    }
  },

  methods: {
    prev() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss">

</style>